import { Button, Spinner } from 'react-bootstrap';

interface Props {
    isSubmit?: boolean;
    isLoading: boolean;
    isDisable?: boolean;
    handlerSubmit?: () => void;
}

export default function DeleteButton({
    isLoading,
    isDisable = false,
    isSubmit = true,
    handlerSubmit,
}: Props) {
    return (
        <Button
            type={isSubmit ? 'submit' : 'button'}
            variant='outline-danger'
            disabled={isLoading || isDisable}
            onClick={() => handlerSubmit && handlerSubmit()}
        >
            {isLoading && (
                <Spinner animation='border' size='sm' role='status'>
                    <span className='visually-hidden'>Eliminando...</span>
                </Spinner>
            )}
            {isLoading ? ' Eliminando...' : 'Eliminar'}
        </Button>
    );
}
